import { type ComponentProps, type FC } from "react";
import { KeepForm } from "@userFrontend/features/publication/components/KeepForm";
import { EntryOrScoutButton } from "@userFrontend/features/publication/components/WorkWithShopWorkCassette/uiParts/EntryOrScoutButton";
import { ScoutDeadlineInformation } from "@userFrontend/features/publication/components/ScoutDeadlineInformation";
import { type ModalLinkParams } from "@userFrontend/features/publication/components/WorkWithShopWorkCassette/type";
import * as styles from "./styles.css";

type Props = {
  login: boolean;
  scoutDeadline?: number;
  // キープボタン用
  keepUrl: string;
  keepGaAction: string;
  keepGaLabel: string;
  hasKept: boolean;
  handleClickLink: (params: ModalLinkParams) => void;
} & Omit<
  ComponentProps<typeof EntryOrScoutButton>,
  "handleClickScoutLink" | "handleClickEntryLink"
>;

export const Buttons: FC<Props> = ({
  login,
  keepUrl,
  keepGaAction,
  keepGaLabel,
  hasKept,
  handleClickLink,
  enterableFlag,
  entriedFlag,
  scoutedFlag,
  scoutedEntryUrl,
  scoutDeadline,
  workCode,
  scoutGaAction,
  scoutGaLabel,
  query,
  entryUrl,
  entryGaAction,
  entryGaLabel,
}) => (
  <div className={styles.outer}>
    {(!login || (!entriedFlag && !scoutedFlag)) && (
      <div className={styles.buttonOuter}>
        <KeepForm
          url={keepUrl}
          query={query}
          gaAction={keepGaAction}
          gaLabel={keepGaLabel}
          workCode={workCode}
          hasKeeped={hasKept}
        >
          キープする
        </KeepForm>
      </div>
    )}
    {scoutedFlag && scoutDeadline && scoutDeadline > 0 ? (
      <div className={styles.scoutDeadLineOuter}>
        <ScoutDeadlineInformation remainingDaysNum={scoutDeadline} />
      </div>
    ) : null}
    <div className={styles.buttonOuter}>
      <EntryOrScoutButton
        entriedFlag={entriedFlag}
        enterableFlag={enterableFlag}
        scoutedFlag={scoutedFlag}
        scoutedEntryUrl={scoutedEntryUrl}
        workCode={workCode}
        scoutGaAction={scoutGaAction}
        scoutGaLabel={scoutGaLabel}
        query={query}
        entryUrl={entryUrl}
        entryGaAction={entryGaAction}
        entryGaLabel={entryGaLabel}
        handleClickLink={handleClickLink}
      />
    </div>
  </div>
);
